import BookingRoleWorkerShiftRejectedReason from "@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftRejectedReason";

export default class RejectAppliedBookingRoleWorkersRequest {
    rejectedReason: BookingRoleWorkerShiftRejectedReason
}